import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HorizontalLayout from "./layouts/HorizontalLayout";
import Beranda from "./pages/Beranda";
import Deskripsi from "./pages/Deskripsi";
import Kebijakan from "./pages/Kebijakan";
import SubMenuPage from "./pages/SubMenuPage";

function App() {
  return (
    <Router>
      <HorizontalLayout>
        <Routes>
          <Route path="/" element={<Beranda />} />
          <Route path="/menu/:menuSlug/:parentId" element={<SubMenuPage />} />
          <Route path="/deskripsi" element={<Deskripsi />} />
          <Route path="/kebijakan" element={<Kebijakan />} />
        </Routes>
      </HorizontalLayout>
    </Router>
  );
}

export default App;
